// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__2Ffgc","spin":"styles_spin__0UPZH"};